import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

import ButtonGral from "../core/ButtonGral";
import ImagenFit from "../core/ImagenFit";

export const SplitPurchaseForm = ({
  onClickHidden,
  isHidden,
  onSplitTheBill,
  selectedFriend,
  categoriesArr,
}) => {
  const [bill, setBill] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [yourExpense, setYourExpense] = useState("");
  const [whoIsPaying, setWhoIsPaying] = useState("");
  const [category, setCategory] = useState("");
  const [concept, setConcept] = useState("");
  const paidByFriend = bill ? bill - yourExpense : "";

  function handleSpilTheBill(e) {
    e.preventDefault();
    if (!bill || !yourExpense) return;
    const deudor =
      whoIsPaying === "me"
        ? `Your friend owes you ${paidByFriend}`
        : `You owe to ${whoIsPaying} $${yourExpense}`;
    console.log(
      `The bill: ${bill}, you expensed ${yourExpense} and your friend expesnsed ${paidByFriend}, the bill was paieed by ${whoIsPaying}
      and ${deudor}; Details: You expensed in ${category} for ${concept}`
    );
    onSplitTheBill(whoIsPaying === "me" ? paidByFriend : -yourExpense);

    setYourExpense("");
    setBill("");
  }
  return (
    <form
      className={isHidden ? "oculto" : ""}
      onSubmit={handleSpilTheBill}
      id="container-SplitPurchaseForm"
    >
      <button onClick={onClickHidden} className="close-form">
        {" "}
        X{" "}
      </button>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "1.4rem",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 0 1rem 0",
        }}
      >
        <h1>
          Split a bill with{" "}
          <span style={{ color: "#ea580c", fontWeight: "bold" }}>
            {(selectedFriend?.name || "...(・∀・)?").split(" ")[0]}
          </span>
        </h1>

        {isMobile && (
          <div className="profile-pi">
            <ImagenFit
              src={
                selectedFriend?.profilePic ??
                "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/splits-bills%2Fpandas.png?alt=media&token=d45078fa-d2c2-4db5-9a5a-322b7fd092d2"
              }
              width={"48px"}
              height={"48px"}
              alt={"profile-pic"}
            />
          </div>
        )}
      </div>
      <div className="container-input-style">
        <label>💸 Bill Value</label>
        <input
          value={bill}
          onChange={(e) => setBill(Number(e.target.value))}
          type="text"
        />
      </div>

      <div className="container-input-style">
        <label>🧍‍♀️ Your Expense</label>
        <input
          onChange={(e) => setYourExpense(Number(e.target.value))}
          value={yourExpense}
          type="text"
        />
      </div>

      <div className="container-input-style">
        <label> {`${selectedFriend.name ?? "😶‍🌫️"}'s expense`}</label>
        <input
          value={paidByFriend}
          placeholder="friend expense"
          type="text"
          disabled
        />
      </div>
      <div className="container-input-style">
        <label>🤑 Who is paying the bill?</label>
        <select
          value={whoIsPaying}
          onChange={(e) => setWhoIsPaying(e.target.value)}
        >
          <option value={"me"}>You</option>
          <option value={"friend"}>{selectedFriend.name}</option>
        </select>
      </div>

      <div className="container-input-style">
        <div style={{ display: "flex", gap: "1.4rem", alignItems: "center" }}>
          <label>Category</label>
          <select onChange={(e) => setCategory(e.target.value)}>
            <option value={category} disabled>
              {" "}
              pick one...
            </option>
            {categoriesArr.map((cat) => (
              <option value={cat} key={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
        <div className="container-input-style">
          <input
            value={concept}
            onChange={(e) => setConcept(e.target.value)}
            placeholder="concept"
            type="text"
          />
        </div>
      </div>
      <div className="btn-split-containere">
        <ButtonGral onClick={onClickHidden} txt={"split"} />
      </div>
    </form>
  );
};

export default SplitPurchaseForm;
